import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import MyCard from './../MyCard.js';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';

class Exam3emeLocal extends React.Component{
  render(){
    return(
      <div>
          <Alert variant="danger">
            <h3>
              Examen locale pour le troisème année secondaire.
            </h3>
          </Alert>






                    <Badge variant="warning"><h4>المديرية الإقليمية بتارودانت</h4></Badge><br/><br/>
                    <Row>
                        <MyCard
                        title="Examen locale maths - 2017"
                        ty="Examen"
                        color1="#a691fa"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/locale/region_taro/Exam-local-maths-coll-alhassan-alawal-3ac-2017.pdf" />

                        <MyCard
                        title="Examen locale maths - 2018"
                        ty="Examen"
                        color1="#a691fa"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/locale/region_taro/Exam-local-maths-coll-alhassan-alawal-3ac-2018.pdf" />


                        <MyCard
                        title="Examen locale maths - 2019"
                        ty="Examen"
                        color1="#a691fa"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/locale/region_taro/Exam-local-maths-coll-alhassan-alawal-3ac-2019.pdf" />
                    </Row>


                    <hr/>




          <Badge variant="warning"><h4>المديرية الإقليمية بالحسيمة</h4></Badge> <br/><br/>

          <Row>
              <MyCard
              title="Examen locale maths - 2014"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_ho/Exam-local-maths-coll-alqods-3ac-2014.pdf" />

              <MyCard
              title="Examen locale maths - 2015"
               ty="Examen"
               color1="#a691fa"
               content=""
               fileUrl="/documents/file/pdf/3/exam/locale/region_ho/Exam-local-maths-coll-lala-mariem-3ac-2015.pdf" />

              <MyCard
              title="Examen locale maths - 2017"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_ho/Exam-local-maths-coll-arabi3-3ac-2017.pdf" />
          </Row>




          <hr/>
          <Badge variant="warning"><h4>المديرية الإقليمية بطنجة أصيلة</h4></Badge><br/><br/>
          <Row>
              <MyCard
              title="Examen locale maths - 2015"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_tang/Exam-local-Corr-maths-coll-almasira-3ac-2015.pdf" />

              <MyCard
              title="Examen locale maths - 2016"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_tang/Exam-local-maths-coll-moh-6-3ac-2016.pdf" />


              <MyCard
              title="Examen locale maths - 2018"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_tang/Exam-local-maths-coll-alaaqad-3ac-2018.pdf" />
          </Row>






          <hr/>
          <Badge variant="warning"><h4>المديرية الإقليمية بصفرو</h4></Badge><br/><br/>

          <Row>
              <MyCard
              title="Examen locale maths - 2015"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_saf/Exam-local-Corr-maths-coll-sidi-boumdin-3ac-2015.pdf" />

              <MyCard
              title="Examen locale maths - 2016"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_saf/Exam-local-maths-coll-sidi-boumdin-3ac-2016.pdf" />


              <MyCard
              title="Examen locale maths - 2017"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_saf/Exam-local-maths-coll-sidi-boumdin-3ac-2017.pdf" />
          </Row>

          <hr/>
          <Badge variant="warning"><h4>جهة مراكش اسفي</h4></Badge><br/><br/>
          <Row>
              <MyCard
              title="Examen locale maths - 2016"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_mar/Exam-local-maths-coll-ibn-alhaitam-3ac-2016.pdf" />

              <MyCard
              title="Examen locale maths - 2017"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_mar/Exam-local-maths-coll-almaali-3ac-2017.pdf" />


              <MyCard
              title="Examen locale maths - 2018"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_mar/Exam-local-maths-coll-wad-adahab-3ac-2018.pdf" />
          </Row>


          <hr/>
          <Badge variant="warning"><h4>المديرية الإقليمية بزاكورة</h4></Badge><br/><br/>
          <Row>
              <MyCard
              title="Examen locale maths - 2015"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_zag/Exam-local-maths-coll-sidi-amro-3ac-2015.pdf" />

              <MyCard
              title="Examen locale maths - 2016"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_zag/Exam-local-maths-coll-ait-wellal-3ac-2016.pdf" />


              <MyCard
              title="Examen locale maths - 2018"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_zag/Exam-local-maths-coll-sidi-amro-3ac-2018.pdf" />
          </Row>

          <hr/>
          <Badge variant="warning"><h4>المديرية الإقليمية بأزيلال</h4></Badge><br/><br/>
          <Row>
              <MyCard
              title="Examen locale maths - 2015"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_azil/Exam-local-Corr-maths-coll-aforar-3ac-2015.pdf" />

              <MyCard
              title="Examen locale maths - 2016"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_azil/Exam-local-maths-coll-tilokit-3ac-2016.pdf" />


              <MyCard
              title="Examen locale maths - 2018"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_azil/Exam-local-Corr-maths-coll-tilokit-3ac-2018.pdf" />
          </Row>






          <hr/>
          <Badge variant="warning"><h4>المديرية الإقليمية بالعيون</h4></Badge><br/><br/>
          <Row>
              <MyCard
              title="Examen locale maths - 2015"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_laay/Exam-local-maths-coll-tariq-ibn-ziad-3ac-2015.pdf" />

              <MyCard
              title="Examen locale maths - 2016"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_laay/Exam-local-Corr-maths-coll-tariq-ibn-ziad-3ac-2016.pdf" />


              <MyCard
              title="Examen locale maths - 2017"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_laay/Exam-local-Corr-maths-coll-othman-ibn-affan-3ac-2017.pdf" />
          </Row>


          <hr/>
          <Badge variant="warning"><h4>جهة الرباط سلا القنيطرة</h4></Badge><br/><br/>
          <Row>
              <MyCard
              title="Examen locale maths - 2015"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_rabat/Exam-local-maths-coll-manarat-alfirdaous-3ac-2015.pdf" />

              <MyCard
              title="Examen locale maths - 2016"
              ty="Examen"
              color1="#a691fa"
              content=""
              fileUrl="/documents/file/pdf/3/exam/locale/region_rabat/Exam-local-maths-coll-3-mars-3ac-2016.pdf" />


          </Row>



      </div>
    );
  }
}

export default Exam3emeLocal;
